<template>
  <div class="d-flex flex-column flex-sm-row" style="transform: rotate(0);">
    <div v-if="imageUrl || loading" class="image-container">
      <b-aspect :aspect='4 / 3' class="responsive-aspect">
        <b-skeleton-img v-if="loading" no-aspect></b-skeleton-img>
        <b-img-lazy v-else class="sectionImg" fluid-grow rounded :src="imageUrl" :alt="name"></b-img-lazy>
      </b-aspect>
    </div>
    <div class="mt-4 mt-sm-0 w-100">

      <div class="mb-3">
        <h1 v-if="name && !loading">{{ name }}</h1>
        <b-skeleton v-if="loading" width="55%" height="48px"></b-skeleton>
      </div>

      <p v-if="!loading" :class="computedParaClasses" v-html="desc"></p>
      <div v-else>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
      </div>

      <div class="pt-2">
        <router-link v-if="slug" :to="`/sections/${slug}`" class="stretched-link no-href">View Section <i
            class="fa fa-long-arrow-right" aria-hidden="true"></i></router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: String,
    name: String,
    desc: String,
    slug: String,
    showFullDescription: Boolean,
    loading: Boolean
  },
  computed: {
    computedParaClasses () {
      return {
        'ql-content': true,
        'text-muted': true,
        'mb-3': true,
        'clamp-line-text': !this.showFullDescription,
      };
    },
  }
}
</script>

<style>
.image-container {
  margin-right: 1.5rem;
}

img.sectionImg {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.clamp-line-text {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.responsive-aspect {
  width: 200px;
  height: 240px;
  background-color: #eee;
}

@media (max-width: 575px) {
  .image-container {
    margin-right: unset;
  }

  .responsive-aspect {
    width: 100%;
    height: 100%;
  }
}
</style>